import React from "react";
import { BrowserRouter } from "react-router-dom";
import MDMApp from "swfrontend/MDMApp";
import CRPRoutes from "./CRPRoutes";
import getRoutes from "./ScreenRouters";
import Forbidden from "../Auth/screens/Forbidden/Forbidden";
import { URLS } from "../LandingPage/constants";
import "./CSS/App.css";
import getHeaderLinks from "./HeaderLinks";
import ErrorHandler from "./Utils/ErrorHandler";
import IdleTimer from "./IdleTimer";

class App extends React.Component {
  render() {
    if(
      window.location.pathname==="/null"
    )
    {
      window.location.href=URLS.HOME
    }
    if (
      window.location.pathname === "/" ||
      window.location.pathname === URLS.HOME ||
      window.location.pathname === URLS.BASEROUTE ||
      window.location.pathname === URLS.REGISTRATION ||
      window.location.pathname === URLS.CONTACTUS ||
      window.location.pathname === URLS.LOGIN ||
      window.location.pathname === URLS.FORGETPASSWORD ||
      window.location.pathname === URLS.RESETPASSWORD ||
      window.location.pathname === URLS.REGISTER_SUCCESS ||
      window.location.pathname === URLS.PRIVACYPOLICY ||
      window.location.pathname === URLS.HOME + "/" ||
      window.location.pathname === URLS.BASEROUTE + "/" ||
      window.location.pathname === URLS.REGISTRATION + "/" ||
      window.location.pathname === URLS.CONTACTUS + "/" ||
      window.location.pathname === URLS.LOGIN + "/" ||
      window.location.pathname === URLS.FORGETPASSWORD + "/" ||
      window.location.pathname === URLS.RESETPASSWORD + "/" ||
      window.location.pathname === URLS.REGISTER_SUCCESS + "/" ||
      window.location.pathname === URLS.PRIVACYPOLICY + "/" ||
      window.location.pathname === URLS.RESETUSERNAME
    ) {
      return (
        <ErrorHandler>
          <CRPRoutes />
        </ErrorHandler>
      );
    }

    if (window.location.href.indexOf(URLS.PORTAL_URL) > -1) {
      return (
        <>
          <BrowserRouter>
            <ErrorHandler>
              <IdleTimer minutes={60000*10} />
              <MDMApp routes={getRoutes} headerLinks={getHeaderLinks} />
            </ErrorHandler>
          </BrowserRouter>
        </>
      );
    }

    return <Forbidden />;
  }
}

export default App;
